import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountTransactionsPage} from 'features/loans/pages/LoanAccountTransactionsPage/LoanAccountTransactionsPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/loans/$accountId/transactions',
)({
  component: LoanAccountTransactionsPage,
  staticData: {crumbKey: 'navigation.transactions'},
});
